type ActionType =
  | 'food'
  | 'snack'
  | 'toy'
  | 'first_aid'
  | 'invitation'
  | 'toilet'
  | 'bath';

export type CareActionReceiveEvent = {
  userId: string;
  eventType: 'CareActionReceive';
  eventProperties: {
    action_type: ActionType;
    item_id?: string;
    result?: 'success' | 'failure';
    byFriend: boolean;
    friendID?: string;
    bPointsConsumed: number;
  };
};

/**
 * Trigger: the player’s pet has received a care action from either the player or other players
 * So, when the player performs a care action for their own pets,
 * both of CareActionFinish and CareActionReceive are triggered for the player
 *
 * When the player performs a care action during a visit, the following three events should be triggered:
 *  - CareActionFinish
 *  - CareActionReceive: for the player’s own pet (User ID: visitor user)
 *  - CareActionReceive: for the other player’s pet (User ID: visited user)
 *
 * @param eventProperties.action_type
 * @param eventProperties.item_id
 * @param eventProperties.result
 * @param eventProperties.byFriend: true if the care was done by other players. false if done by the pet’s owner
 * @param eventProperties.friendID: User ID of the friend player if the care was done by another player. null if not
 * @param eventProperties.bPointsConsumed: Amount of buruburu points consumed for the care action
 */
export const getCareActionReceiveEvent = (
  userId: string,
  eventProperties: CareActionReceiveEvent['eventProperties'],
): CareActionReceiveEvent => ({
  userId,
  eventType: 'CareActionReceive',
  eventProperties,
});
